/**
 * Разница часового пояса города относительно сервера для запросов слотов.
 *
 * Берёт первое валидное значение из кандидатов (`context.town.timedelta`,
 * `lpu.town.timedelta` и т.п.).
 */
export default function getTownTimedelta(
  candidates: Array<number | string | null | undefined>,
): number {
  const fromCandidates = candidates
    .map(value => {
      if (value == null || value === '') {
        return null
      }

      const parsed = Number(value)

      return Number.isFinite(parsed) ? parsed : null
    })
    .find(value => value != null)

  return fromCandidates ?? 0
}
